import reduceReducers from 'reduce-reducers';

//Siblings reducers
import paperworkReducer from './paperwork-reducer';

export default reduceReducers(paperworkReducer);
